import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import { Icon } from '@iconify/react';

export default function ChargerConfigModal({ chargerId, url, open, onClose }) {
  const fullUrl = `${url}${chargerId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(fullUrl);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Charger Configuration URL
          <IconButton onClick={onClose} edge="end">
            <Icon icon="mdi:close" width={20} height={20} />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            WebSocket URL for Charger <strong>{chargerId}</strong>
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f9fafb',
              border: '1px solid #ddd',
              borderRadius: 1,
              px: 2,
              py: 1,
              mt: 1,
            }}
          >
            <Typography
              component="span"
              sx={{ fontFamily: 'monospace', fontSize: '0.9rem', color: 'primary.main', flexGrow: 1 }}
            >
              {fullUrl}
            </Typography>
            <Tooltip title="Copy">
              <IconButton onClick={handleCopy}>
                <Icon icon="mdi:content-copy" width={20} height={20} />
              </IconButton>
            </Tooltip>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
            This URL can be used to connect to the charger’s WebSocket endpoint for real-time communication.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
